PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
PREFIX ccf: <http://purl.org/ccf/>
PREFIX dcterms: <http://purl.org/dc/terms/>
PREFIX skos: <http://www.w3.org/2004/02/skos/core#>
PREFIX DSGraphs: <https://purl.humanatlas.io/collection/ds-graphs>
PREFIX DSGraphsExtra: <https://purl.humanatlas.io/graph/ds-graphs-enrichments>

CONSTRUCT {
  ?block rdf:type ccf:Sample ;
          rdfs:label ?sampleLabel ;
          rdfs:comment ?sampleDescription ;
          ccf:url ?sampleLink ;
          ccf:sample_type ?sampleType ;
          ccf:generates_dataset ?dataset ;
          ccf:has_registration_location ?rui_location ;
          ccf:comes_from ?donor ;
          ccf:subdivided_into_sections ?section ;
          ccf:section_count ?sectionCount ;
          ccf:section_size ?sectionSize ;
          ccf:section_size_unit ?sectionUnits .
  ?donor rdf:type ccf:Donor ;
         rdfs:label ?donorLabel ;
         rdfs:comment ?donorDescription ;
         ccf:url ?donorLink ;
         ccf:tissue_provider_name ?provider .
  ?section rdf:type ccf:Sample ;
           rdfs:label ?sectionLabel ;
           rdfs:comment ?sectionDescription ;
           ccf:url ?sectionLink ;
           ccf:sample_type ?sectionType ;
           ccf:generates_dataset ?sectionDataset ;
           ccf:section_number ?sectionNumber .
  ?dataset rdf:type ccf:Dataset ;
           rdfs:label ?datasetLabel ;
           rdfs:comment ?datasetDescription ;
           ccf:url ?datasetLink ;
           ccf:technology ?technology ;
           ccf:thumbnail ?thumbnail .
  ?sectionDataset rdf:type ccf:Dataset ;
                  rdfs:label ?sectionDatasetLabel ;
                  rdfs:comment ?sectionDatasetDescription ;
                  ccf:url ?sectionDatasetLink ;
                  ccf:technology ?sectionTechnology ;
                  ccf:thumbnail ?sectionThumbnail .
}
FROM DSGraphs:
FROM NAMED DSGraphsExtra:
WHERE {

  OPTIONAL {
    ?block ccf:section_count ?sectionCount ;
      ccf:section_size ?sectionSize ;
      ccf:section_size_unit ?sectionUnits .
  }

  OPTIONAL {
    ?block ccf:subdivided_into_sections ?section .
    ?section rdf:type ccf:Sample ;
            rdfs:label ?sectionLabel ;
            rdfs:comment ?sectionDescription ;
            # skos:prefLabel ?sectionLabel ;
            # dcterms:description ?sectionDescription ;
            ccf:url ?sectionLink ;
            ccf:sample_type ?sectionType ;
            ccf:section_number ?sectionNumber .

    OPTIONAL {
      ?section ccf:generates_dataset ?sectionDataset .
      ?sectionDataset rdf:type ccf:Dataset ;
                  rdfs:label ?sectionDatasetLabel ;
                  rdfs:comment ?sectionDatasetDescription ;
                  # skos:prefLabel ?sectionDatasetLabel ;
                  # dcterms:description ?sectionDatasetDescription ;
                  ccf:url ?sectionDatasetLink ;
                  ccf:technology ?sectionTechnology ;
                  ccf:thumbnail ?sectionThumbnail .
    }
  }

  OPTIONAL {
    ?block ccf:generates_dataset ?dataset .
    ?dataset rdf:type ccf:Dataset ;
             rdfs:label ?datasetLabel ;
             rdfs:comment ?datasetDescription ;
            #  skos:prefLabel ?datasetLabel ;
            #  dcterms:description ?datasetDescription ;
             ccf:url ?datasetLink ;
             ccf:technology ?technology ;
             ccf:thumbnail ?thumbnail .
  }

  ?block rdf:type ccf:Sample ;
          rdfs:label ?sampleLabel ;
          rdfs:comment ?sampleDescription ;
          # skos:prefLabel ?sampleLabel ;
          # dcterms:description ?sampleDescription ;
          ccf:url ?sampleLink ;
          ccf:sample_type ?sampleType ;
          ccf:has_registration_location ?rui_location ;
          ccf:comes_from ?donor .
  ?donor rdf:type ccf:Donor ;
         rdfs:label ?donorLabel ;
         rdfs:comment ?donorDescription ;
         #  skos:prefLabel ?donorLabel ;
         #  dcterms:description ?donorDescription ;
         ccf:url ?donorLink ;
         ccf:tissue_provider_name ?provider .

  #{{FILTER}}
}
